import { useMemo } from 'react';

import { regularValidationZip, regularValidationStateCode } from '@utils';
import { useLocation } from '@utils/hooks';
import { LocationStateType } from '@utils/types';

import { useStore } from '@modules';

import { isValid } from './validateBillingAddress';

export const useInitialValues = () => {
  const [store] = useStore();
  const location = useLocation<LocationStateType['billingAddress']>();
  const { global, user } = store;
  const { data } = user;

  const countrySelect = useMemo(() => {
    let code;

    if (location.state?.address) {
      code = location.state.address?.country_code?.toLowerCase();
    } else {
      code = data?.billing_address?.country_code;
    }

    return global.countries.find(item => item.code === code);
  }, [global.countries, data?.billing_address]);

  const stateSelect = useMemo(() => {
    let code;

    if (location.state?.address) {
      code = location.state.address.state_code;
    } else {
      code = data?.billing_address?.state_code;
    }

    return global.states.find(item => item.code === code);
  }, [global.states, data?.billing_address]);

  const values = useMemo(() => {
    let obj;

    if (location.state?.address) {
      obj = location.state.address;
    } else {
      obj = data?.billing_address;
    }

    return {
      country_code:
        obj?.country_code && isValid(obj.country_code) ? obj.country_code.toLowerCase() : '',
      street_line_1: obj?.street_line_1 && isValid(obj.street_line_1) ? obj.street_line_1 : '',
      street_line_2: obj?.street_line_2 && isValid(obj.street_line_2) ? obj.street_line_2 : '',
      city: obj?.city && isValid(obj.city) ? obj.city : '',
      zip_code: obj?.zip_code && isValid(obj.zip_code, regularValidationZip) ? obj.zip_code : '',
      state_code:
        obj?.state_code && isValid(obj.state_code, regularValidationStateCode)
          ? obj.state_code
          : '',
    };
  }, [data?.billing_address]);

  return { countrySelect, stateSelect, values };
};
